import React from 'react'
import { useState, useEffect, useContext, useImperativeHandle, forwardRef  } from 'react';

import { AppContext } from '../Provider/Provider';

import { TrashIcon } from "@heroicons/react/solid";

const Tabla = forwardRef(({ name, tupla, returnTotalkWhCategoria }, ref) => {

  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);
  
  const [tuplaFlag, setTuplaFlag] = useState({});

  const [arrayOfElements, setArrayOfElements] = useState([]);

  const [currentName, setCurrentName] = useState("");


  if(currentName === "") {
    setCurrentName(name);
  } else if(currentName !== name) {

    let anArray = valoresConsumoState.tablasPorCategoria[currentName];

    setArrayOfElements(anArray);

    setCurrentName(name);
  }


  useImperativeHandle(
    ref,
    () => ({
      clearArrayOfElements(){
        clearArrayOfElementsChild();
      }
     }),
  )

  
  const verifyTupla = () => {
    if (typeof tupla !== "undefined") {
      if (
        tupla.electrodomestico !== undefined &&
        tupla.cantidad !== undefined &&
        tupla.usoDiario !== undefined &&
        tupla.kWh !== undefined &&
        !isNaN(tupla.kWh) &&
        tupla.consumoBimestral !== undefined &&
        !isNaN(tupla.consumoBimestral)
      ) {
          if (JSON.stringify(tupla) !== JSON.stringify(tuplaFlag)) {
            addToArrayOfElements();
          }
          setTuplaFlag(tupla);
      }
    }
  };


  const addToArrayOfElements = () => {
    var localValores = Object.create(valoresConsumoState);
    
    let anArray = arrayOfElements;
    let currentValue = 0;
    let sumValue = localValores.ValoresCategoriaCard[name].kWh;
    let cantE = localValores.ValoresCategoriaCard[name].Cant;
    let digitos = 2;

    anArray.push(tupla);
    setArrayOfElements(anArray);

    currentValue = tupla.consumoBimestral; //valor de consumo del item
    
    cantE++;
    
    localValores.ValoresCategoriaCard[name].kWh = sumValue + currentValue;
    localValores.ValoresCategoriaCard[name].Cant = cantE;

    localValores.TotalkWhBim += currentValue;
    
    /** Valor para el Medidor */
    localValores.TotalkWhBim = Math.trunc(
                                localValores.TotalkWhBim * Math.pow(10, digitos)
                               ) / Math.pow(10, digitos); //Valor para el Medidor

    /** Valor para mostrar en la card de la categoría */ 
    handleTotalkWhCategoria(localValores.ValoresCategoriaCard[name].kWh);

    setValoresConsumoState(localValores);
  };


  const subtractFromArrayOfElements = (index) => {
    var localValores = Object.create(valoresConsumoState);
    
    let anArray = arrayOfElements;
    let sumValue = localValores.ValoresCategoriaCard[name].kWh;
    let itemResta = 0;
    let cantE = localValores.ValoresCategoriaCard[name].Cant;
    let valorMedidor = valoresConsumoState.TotalkWhBim;
    let digitos = 2;

    itemResta = arrayOfElements[index].consumoBimestral; //resta el valor del item
    
    cantE--;
    
    localValores.ValoresCategoriaCard[name].kWh = sumValue - itemResta;
    localValores.ValoresCategoriaCard[name].Cant = cantE;
    
    valorMedidor -= itemResta; 

    /** Valor para el Medidor */
    localValores.TotalkWhBim = Math.trunc(valorMedidor * Math.pow(10, digitos)) / Math.pow(10, digitos); 

    /** Valor para mostrar en la card de la categoría */ 
    handleTotalkWhCategoria( localValores.ValoresCategoriaCard[name].kWh); 
    
    setValoresConsumoState(localValores);

    anArray.splice(index, 1);
    setArrayOfElements(anArray);
  };


  const clearArrayOfElementsChild = () => {
      var localValores = Object.create(valoresConsumoState);
      
      let anArray = [];
      let clear = 0;
      let sumValue = localValores.ValoresCategoriaCard[name].kWh;
      let digitos = 2;

      localValores.TotalkWhBim = Math.trunc(
                                  (localValores.TotalkWhBim -= sumValue) * Math.pow(10, digitos)
                                 ) / Math.pow(10, digitos); // Valor para el Medidor

      localValores.ValoresCategoriaCard[name].kWh = clear;
      localValores.ValoresCategoriaCard[name].Cant = clear;
      valoresConsumoState.tablasPorCategoria[name] = [];
      
      setArrayOfElements(anArray);

      handleTotalkWhCategoria(clear);

      setValoresConsumoState(localValores);
  };


  const handleTotalkWhCategoria = (s) => {
    returnTotalkWhCategoria(s);
  };

  const renderHeader = () => {
    
    let headerElement = [
      "electrodoméstico",
      "cantidad",
      "kWh",
      "uso diario",
      "consumo bimestral",
      ""
    ];

    return headerElement.map((key, index) => {
      return (
        <th key={index} className={"px-1 py-0 md:py-0.5 font-medium text-xs text-center"}>
          {key.toUpperCase()}
        </th>
      );
    });
  };


  const renderBody = () => {
    return (
      arrayOfElements &&
      arrayOfElements.map(
        (
          { electrodomestico, cantidad, kWh, usoDiario, consumoBimestral },
          index
        ) => {
          return (
            <tr key={index}>
              <td className={"border border-dpecGreen px-1 py-0 md:py-1"}>
                {electrodomestico}
              </td>
              <td className={"border border-dpecGreen md:px-2"}>
                {cantidad}
              </td>
              <td className={"border border-dpecGreen md:px-2"}>
                {kWh}
              </td>
              <td className={"border border-dpecGreen md:px-2 text-right"}>
                {usoDiario}
              </td>
              <td className={"border border-dpecGreen md:px-2 text-right"}>
                {consumoBimestral} kWh
              </td>
              <td className={"border border-dpecGreen md:px-2 text-right"}>
                <button
                  title={"Eliminar Item"}
                  type={"button"}
                  onClick={() => subtractFromArrayOfElements(index)}
                  className={"h-4 w-4 text-gray-500 | hover:text-red-500 | focus:outline-none"}
                >
                  <TrashIcon />
                </button>
              </td>
            </tr>
          );
        }
      )
    );
  };

  useEffect(() => {
    verifyTupla();

    setArrayOfElements(valoresConsumoState.tablasPorCategoria[name]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderBody()]);

  return (
    <>
      {arrayOfElements.length === 0 || name !== currentName ? (
        <div
          className={
            " bg-white text-green-700 text-center text-sm font-bold p-4"
          }
        >
          Aquí verá los datos
        </div>
      ) : (
        <table
          className={
            "table-auto border-collapse border border-dpecGreen | shadow-md w-full"
          }
        >
          <thead className={"bg-dpecGreen text-white"}>
            <tr>{renderHeader()}</tr>
          </thead>
          <tbody
            className={" bg-white text-green-700 text-center text-xs font-bold"}
          >
            {renderBody()}
          </tbody>
        </table>
      )}
    </>
  );
});

export default Tabla
